var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { staticClass: "internal-page-main-section col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c(
          "div",
          { staticClass: "row" },
          [
            _vm._l(_vm.hrTeamList, function(text, index) {
              return [
                index == 0
                  ? [
                      index + 1 == _vm.hrTeamList.length
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "program-section-main hr-team-detail-main col-12 float-l pb-60",
                                attrs: { id: "hr_" + text.id }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "program-img-left col-12 col-sm-4 col-md-4 col-lg-4"
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "hover-home-eefect employee-border"
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: text.profile_image,
                                                alt: "Elizabeth Lizarraga"
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "program-img-right col-12 col-sm-8 col-md-8 col-lg-8"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          text.last_name != "" ||
                                          text.first_name != ""
                                            ? [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-1"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          text.first_name
                                                        ) +
                                                        " " +
                                                        _vm._s(text.last_name) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.post != "" ||
                                          text.team_designation != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(text.post) +
                                                        ", " +
                                                        _vm._s(
                                                          text.team_designation
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.description != ""
                                            ? [
                                                _c("p", {
                                                  staticClass:
                                                    "employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      text.description
                                                    )
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.quote != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " “ " +
                                                        _vm._s(text.quote) +
                                                        " ” "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.quote_name != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " - " +
                                                        _vm._s(
                                                          text.quote_name
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        : [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "program-section-main hr-team-detail-main col-12 float-l pb-60 border-bottom-dddddd",
                                attrs: { id: "hr_" + text.id }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "program-img-left col-12 col-sm-4 col-md-4 col-lg-4"
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "hover-home-eefect employee-border"
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: text.profile_image,
                                                alt: "Elizabeth Lizarraga"
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "program-img-right col-12 col-sm-8 col-md-8 col-lg-8"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          text.last_name != "" ||
                                          text.first_name != ""
                                            ? [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-1"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          text.first_name
                                                        ) +
                                                        " " +
                                                        _vm._s(text.last_name) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.post != "" ||
                                          text.team_designation != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(text.post) +
                                                        ", " +
                                                        _vm._s(
                                                          text.team_designation
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.description != ""
                                            ? [
                                                _c("p", {
                                                  staticClass:
                                                    "employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      text.description
                                                    )
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.quote != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " “ " +
                                                        _vm._s(text.quote) +
                                                        " ” "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.quote_name != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " - " +
                                                        _vm._s(
                                                          text.quote_name
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                    ]
                  : [
                      index + 1 == _vm.hrTeamList.length
                        ? [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "program-section-main hr-team-detail-main col-12 float-l pb-50 pt-60",
                                attrs: { id: "hr_" + text.id }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "program-img-left col-12 col-sm-4 col-md-4 col-lg-4"
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "hover-home-eefect employee-border"
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: text.profile_image,
                                                alt: "Elizabeth Lizarraga"
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "program-img-right col-12 col-sm-8 col-md-8 col-lg-8"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          text.last_name != "" ||
                                          text.first_name != ""
                                            ? [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-1"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          text.first_name
                                                        ) +
                                                        " " +
                                                        _vm._s(text.last_name) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.post != "" ||
                                          text.team_designation != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(text.post) +
                                                        ", " +
                                                        _vm._s(
                                                          text.team_designation
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.description != ""
                                            ? [
                                                _c("p", {
                                                  staticClass:
                                                    "employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      text.description
                                                    )
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.quote != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " “ " +
                                                        _vm._s(text.quote) +
                                                        " ” "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.quote_name != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " - " +
                                                        _vm._s(
                                                          text.quote_name
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        : [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "program-section-main hr-team-detail-main col-12 float-l pb-50 pt-60 border-bottom-dddddd",
                                attrs: { id: "hr_" + text.id }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "program-img-left col-12 col-sm-4 col-md-4 col-lg-4"
                                    },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "hover-home-eefect employee-border"
                                          },
                                          [
                                            _c("img", {
                                              attrs: {
                                                src: text.profile_image,
                                                alt: "Elizabeth Lizarraga"
                                              }
                                            })
                                          ]
                                        )
                                      ])
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "program-img-right col-12 col-sm-8 col-md-8 col-lg-8"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "row" },
                                        [
                                          text.last_name != "" ||
                                          text.first_name != ""
                                            ? [
                                                _c(
                                                  "h3",
                                                  {
                                                    staticClass:
                                                      "team-employee-name color-red heading-text-22 line-height-26 font-text-bold-mont width-full float-l pb-1"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          text.first_name
                                                        ) +
                                                        " " +
                                                        _vm._s(text.last_name) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.post != "" ||
                                          text.team_designation != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "employee-dest color-333333 heading-text-14 line-height-16 font-text-semi-medium-mont width-full float-l pb-40"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(text.post) +
                                                        ", " +
                                                        _vm._s(
                                                          text.team_designation
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.description != ""
                                            ? [
                                                _c("p", {
                                                  staticClass:
                                                    "employee-detail-dest color-5f727f heading-text-14 line-height-20 font-text-semi-medium-mont width-full float-l pb-45",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      text.description
                                                    )
                                                  }
                                                })
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.quote != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "employee-detail-short color-blue heading-text-20 line-height-24 font-text-mefium-italic-mont width-full float-l pb-25"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " “ " +
                                                        _vm._s(text.quote) +
                                                        " ” "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e(),
                                          _vm._v(" "),
                                          text.quote_name != ""
                                            ? [
                                                _c(
                                                  "p",
                                                  {
                                                    staticClass:
                                                      "des-member-name color-333333 heading-text-16 line-height-20 font-text-semi-medium-mont width-full float-l"
                                                  },
                                                  [
                                                    _vm._v(
                                                      " - " +
                                                        _vm._s(
                                                          text.quote_name
                                                        ) +
                                                        " "
                                                    )
                                                  ]
                                                )
                                              ]
                                            : _vm._e()
                                        ],
                                        2
                                      )
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                    ]
              ]
            })
          ],
          2
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("section", { staticClass: "internal-page-banner-main col-12" }, [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "page-title" }, [
            _c("h1", [_vm._v(" Meet the HR Team ")])
          ])
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4dfc50be", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4dfc50be","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/MeetHRTeam.vue
// module id = null
// module chunks = 